import { TimeInput } from "@nextui-org/react";
import { parseAbsoluteToLocal, Time } from "@internationalized/date";
import { FC, useEffect, useState } from "react";

interface ITimeInput {
  onChange: (formattedTime: string) => void;
  initialTime: string | null;
}

const TimePicker: FC<ITimeInput> = ({ onChange, initialTime }) => {
  const [selectedTime, setSelectedTime] = useState<Time | null>(null);

  useEffect(() => {
    if (initialTime) {
      try {
        const zoned = parseAbsoluteToLocal(initialTime);
        setSelectedTime(new Time(zoned.hour, zoned.minute));
      } catch (e) {
        console.warn("Invalid initialTime format:", initialTime);
      }
    }
  }, [initialTime]);

  const handleTimeChange = (time: Time | null) => {
    setSelectedTime(time);
    if (time) {
      const formatted = `${String(time.hour).padStart(2, "0")}:${String(time.minute).padStart(2, "0")}`;
      onChange(formatted); // Send "HH:mm" format back to parent
    }
  };

  return (
    <div className="time-input">
      <TimeInput
        granularity="minute"
        hourCycle={12}
        value={selectedTime}
        onChange={handleTimeChange}
        className="customize-time-input"
      />
    </div>
  );
};

export default TimePicker;
